import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    preSelectRuleSetId: '',
    preSelectRuleId: '',
    unreadUserLogList: {},
  },
  getters: {
    preSelectRuleSetId: (state) => state.preSelectRuleSetId,
    preSelectRuleId: (state) => state.preSelectRuleId,
    unreadUserLogList: (state) => state.unreadUserLogList,
  },
  actions: {
    setPreSelectRule(context, params) {
      const { ruleSetId, ruleId } = params;
      context.commit('setPreSelectRuleSetId', ruleSetId);
      context.commit('setPreSelectRuleId', ruleId);
    },
    unreadUserLogList: (state) => state.unreadUserLogList,
    setUnreadLogChannelList(context, params) {
      context.commit('setUnreadLogChannelList', params);
    },
    clearUnreadValue(context, params) {
      context.commit('setUserUnreadValue', params);
    },
  },
  mutations: {
    setPreSelectRuleSetId(state, data) {
      Vue.set(state, 'preSelectRuleSetId', data);
    },
    setPreSelectRuleId(state, data) {
      Vue.set(state, 'preSelectRuleId', data);
    },
    setUnreadLogChannelList(state, obj) {
      const { channel, data } = obj;
      Vue.set(state.unreadUserLogList, channel, data);
    },
    setUserUnreadValue(state, obj) {
      const { channel, id } = obj;
      if (state.unreadUserLogList[channel] && state.unreadUserLogList[channel][id]) {
        Vue.delete(state.unreadUserLogList[channel], id);
      }
    },
  },
};
